// Central config for onboarding / tours.
// Keep thresholds and localStorage keys here so UX tweaks don't require code spelunking.

export const onboardingConfig = {
  // PlanSetup tour: show on desktop when loginCount <= this threshold,
  // unless user discarded it via localStorage.
  loginCountTourPlanSetUpThreshold: 1,
  discardPlanSetupTourStorageKey: "discardPlanSetupTour",

  // HomeTrainer tour nudge: show on desktop for "new-ish" users when their
  // completed sessions / progress count <= this threshold.
  // (Existing behavior used `completedSessionsCount > 5` to stop showing the nudge.)
  progressCountTourThreshold: 0,
  tourHasBeenShownStorageKey: "tourHasBeenShown",
};


